import { useEffect, useState } from "react"

interface CallBackProp {
  previousScrollTop: number
  currentScrollTop: number
}

type CallBack = (props: CallBackProp) => void

function useDocumentScrollThrottled(callback: CallBack) {
  const [, setScrollPosition] = useState(0)
  let previousScrollTop = 0

  function handleDocumentScroll() {
    const { scrollTop: currentScrollTop } =
      document.documentElement || document.body

    setScrollPosition(previousPosition => {
      previousScrollTop = previousPosition
      return currentScrollTop
    })

    callback({ previousScrollTop, currentScrollTop })
  }

  useEffect(() => {
    window.addEventListener("scroll", handleDocumentScroll)

    return () => window.removeEventListener("scroll", handleDocumentScroll)
  }, [])
}

export default useDocumentScrollThrottled
